import { momentValue, getLocale } from '~/utils';

const dateValue = value => value && momentValue(value).format(value.length <= 10 ? getLocale().formats.date : 'DD/MM/YYYY HH:mm:ss');

export default dateValue;
